// test588
(588 && 0);
